var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 447 447",
    style: {
      enableBackground: "new 0 0 447 447"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M322.505,119c0,0,57.49,62,14.49,103s-113.49-29-113.49-29s-70.5,70-113.5,29s14.49-103,14.49-103 h198H322.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M242.005,118c0,0,25,45-18,86s-0.5-11-0.5-11 s-70.5,70-113.5,29s14.49-103,14.49-103L242.005,118L242.005,118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M142.298,240.867c-14.001,0.001-26.28-4.844-36.434-14.525 c-19.568-18.658-23.108-44.114-10.238-73.616c9.298-21.314,23.854-37.142,24.47-37.806l8.799,8.159l-4.399-4.08l4.402,4.076 c-0.138,0.15-13.933,15.19-22.38,34.694c-10.702,24.708-8.136,44.857,7.628,59.887c38.331,36.548,104.469-28.256,105.132-28.916 l8.455,8.516c-0.745,0.74-18.513,18.259-42.01,30.901C169.974,236.633,155.383,240.866,142.298,240.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M304.703,240.867c-13.085,0-27.671-4.233-43.421-12.708c-23.494-12.643-41.261-30.162-42.005-30.901 l8.455-8.515c0.517,0.512,40.942,40.058,76.861,40.059c10.107,0,19.856-3.131,28.261-11.144 c15.818-15.083,18.349-35.314,7.521-60.134c-8.492-19.466-22.134-34.297-22.271-34.444l8.799-8.159 c0.615,0.664,15.172,16.492,24.47,37.806c12.87,29.502,9.33,54.958-10.238,73.616C330.983,236.022,318.702,240.867,304.703,240.867 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B239"
    },
    d: "M272.855,269.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V441h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M153.015,317v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C150.025,293.12,153.015,304.71,153.015,317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M341.015,356.11V441h-47.04V317c0-12.29,2.99-23.88,8.29-34.08 C325.655,298.84,341.015,325.69,341.015,356.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M349,441h-12v-78.69c0-25.831-11.67-50.163-32.858-68.515C282.713,275.226,254.163,265,223.75,265 c-62.446,0-113.25,43.653-113.25,97.31V441h-12v-78.69C98.5,302.036,154.687,253,223.75,253c33.3,0,64.64,11.267,88.249,31.726 C335.859,305.391,349,332.944,349,362.31V441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M299.975,441h-12V317c0-12.816,3.101-25.558,8.966-36.846l10.648,5.533 c-5.053,9.724-7.614,20.259-7.614,31.313V441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M321.015,427c-3.313,0-6-2.687-6-6v-73c0-3.313,2.687-6,6-6s6,2.687,6,6v73 C327.015,424.313,324.328,427,321.015,427z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M149.665,294.92c-15.21,15.89-24.56,37.45-24.56,61.19 V439h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C146.705,286.74,148.365,290.75,149.665,294.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M159.015,441h-12V317c0-11.054-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.289,8.966,24.03,8.966,36.846V441z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M257.979,417h-68.96c-23.159,0-42-18.841-42-42h12c0,16.542,13.458,30,30,30h68.96 c16.542,0,30-13.458,30-30h12C299.979,398.159,281.139,417,257.979,417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M257.979,399c-3.313,0-6-2.687-6-6s2.687-6,6-6c6.617,0,12-5.383,12-12c0-3.313,2.687-6,6-6 s6,2.687,6,6C281.979,388.234,271.213,399,257.979,399z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M265.385,261v65.36c0,14.71-11.93,26.64-26.64,26.64h-30.72c-14.71,0-26.64-11.93-26.64-26.64V261 c12.5,6.75,26.8,10.58,41.99,10.58C238.585,271.58,252.885,267.75,265.385,261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M238.745,359h-30.72c-17.998,0-32.641-14.642-32.641-32.64V261h12v65.36 c0,11.381,9.26,20.64,20.641,20.64h30.72c11.381,0,20.64-9.259,20.64-20.64V261h12v65.36 C271.385,344.358,256.743,359,238.745,359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M223.385,359c-3.313,0-6-2.687-6-6v-15c0-3.313,2.687-6,6-6s6,2.687,6,6v15 C229.385,356.313,226.698,359,223.385,359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M264.8,258c-3.405,8.5,1.955,17.06,0.585,19.18 c-6.42,10.03-14.81,18.67-24.62,25.39c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03 c-5.24,0-6.11-4.72-9.44-7.26V261c11.87,5.92,29.24,12,43.41,12C242.655,273,250.9,267.09,264.8,258z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M355,447H92.229c-3.313,0-6-2.687-6-6s2.687-6,6-6H355c3.313,0,6,2.687,6,6S358.313,447,355,447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M387,447h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S390.313,447,387,447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M71,447H60c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S74.313,447,71,447z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 142.932,
    cy: 159,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 304.067,
    cy: 159,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M142.933,192.89c-18.688,0-33.891-15.203-33.891-33.89s15.203-33.89,33.891-33.89 c18.687,0,33.89,15.203,33.89,33.89S161.619,192.89,142.933,192.89z M142.933,137.11c-12.07,0-21.891,9.82-21.891,21.89 s9.82,21.89,21.891,21.89s21.89-9.82,21.89-21.89S155.003,137.11,142.933,137.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M304.067,192.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S322.754,192.89,304.067,192.89z M304.067,137.11c-12.07,0-21.89,9.82-21.89,21.89 s9.819,21.89,21.89,21.89s21.89-9.82,21.89-21.89S316.138,137.11,304.067,137.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M272.86,254.97c-14.1,9.49-31.08,15.03-49.36,15.03s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4C150.28,238.63,135,211.85,135,181.5V159v-51.5c0-48.877,39.623-88.5,88.5-88.5l0,0 c48.877,0,88.5,39.623,88.5,88.5V159v22.5c0,30.35-15.28,57.13-38.56,73.07C273.25,254.71,273.05,254.84,272.86,254.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M223.5,276c-18.88,0-37.106-5.551-52.71-16.052l-0.189-0.128c-0.167-0.112-0.335-0.228-0.5-0.346 C144.364,241.817,129,212.674,129,181.5v-74c0-52.107,42.393-94.5,94.5-94.5S318,55.393,318,107.5v74 c0,31.172-15.362,60.313-41.097,77.97c-0.173,0.125-0.35,0.245-0.524,0.363l-0.13,0.088c-0.014,0.009-0.026,0.018-0.039,0.027 C260.606,270.449,242.38,276,223.5,276z M223.5,25c-45.49,0-82.5,37.009-82.5,82.5v74c0,27.241,13.439,52.707,35.949,68.119 c0.057,0.039,0.111,0.078,0.167,0.118l0.425,0.29C191.105,259.156,207.016,264,223.5,264s32.395-4.844,46.009-14.007l0.363-0.247 c0.052-0.038,0.124-0.09,0.178-0.126C292.561,234.206,306,208.741,306,181.5v-74C306,62.009,268.99,25,223.5,25z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M223.5,229.01c-4.869,0-9.738-0.513-14.572-1.538c-3.242-0.688-5.313-3.873-4.625-7.114 c0.687-3.241,3.875-5.311,7.113-4.625c8.02,1.7,16.148,1.7,24.168,0c3.241-0.686,6.428,1.383,7.113,4.625 c0.688,3.242-1.383,6.427-4.625,7.114C233.238,228.497,228.369,229.01,223.5,229.01z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M224.005,242h-1.01c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.01c2.209,0,4,1.791,4,4 S226.214,242,224.005,242z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M252.027,153.414c-2.725,0-5.19-1.868-5.838-4.635c-0.754-3.227,1.25-6.454,4.477-7.209 c9.703-2.269,19.963-2.27,29.668,0c3.227,0.754,5.23,3.982,4.477,7.208c-0.755,3.227-3.977,5.23-7.209,4.476 c-7.919-1.852-16.288-1.852-24.203,0C252.939,153.362,252.479,153.414,252.027,153.414z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M205.14,254.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 C150.28,238.63,135,211.85,135,181.5V159c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.305,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 C166.822,158.99,166.412,159,166,159v22.5c0,30.35,15.28,57.13,38.56,73.07C204.75,254.71,204.95,254.84,205.14,254.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 189.16,
    cy: 170.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M173.83,177.208c-1.533,0-3.065-0.583-4.236-1.751c-2.347-2.34-2.353-6.139-0.013-8.485 c6.153-6.171,15.549-7.746,23.376-3.919c2.978,1.455,4.211,5.048,2.756,8.025c-1.456,2.976-5.049,4.211-8.025,2.756 c-3.219-1.573-7.079-0.926-9.608,1.611C176.907,176.62,175.368,177.208,173.83,177.208z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 257.84,
    cy: 170.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M273.169,177.208c-1.539,0-3.077-0.588-4.249-1.764c-2.53-2.537-6.391-3.184-9.607-1.611 c-2.978,1.456-6.569,0.221-8.025-2.755c-1.455-2.977-0.222-6.57,2.756-8.025c7.826-3.828,17.223-2.252,23.375,3.919 c2.34,2.347,2.334,6.146-0.013,8.485C276.234,176.624,274.701,177.208,273.169,177.208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M216.557,202c-3.313,0-6-2.687-6-6v-32.927c0-2.692-1.515-5.195-3.858-6.375 c-7.192-3.622-19.527-7.154-37.439-3.412c-3.247,0.674-6.423-1.403-7.1-4.647c-0.678-3.244,1.403-6.422,4.646-7.1 c21.306-4.448,36.389-0.04,45.289,4.441c6.453,3.25,10.462,9.799,10.462,17.093V196C222.557,199.313,219.87,202,216.557,202z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 124.495,
    y: 81,
    style: {
      fill: "#F7774B"
    },
    width: 198,
    height: 38
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M323.995,48c11.19,14.29-1.5,33-1.5,33h-198c0,0-12.68-18.71-1.49-33 c25.33-32.33,71.33-42,100.49-42C252.665,6,298.665,15.67,323.995,48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M169.405,48c-11.19,14.29,1.49,33,1.49,33h-46.4 c0,0-12.68-18.71-1.49-33c25.33-32.33,71.33-42,100.49-42c6.95,0,14.85,0.55,23.2,1.82C219.995,11.89,188.705,23.37,169.405,48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M322.495,87h-198c-1.99,0-3.851-0.987-4.967-2.634c-0.152-0.225-3.751-5.584-5.762-12.921 c-2.839-10.361-1.278-19.747,4.515-27.144c12.145-15.501,29.484-27.305,51.537-35.083C192.557,1.198,213.209,0,223.495,0 c10.289,0,30.945,1.198,53.686,9.218c22.054,7.778,39.394,19.582,51.537,35.082c0.001,0,0.001,0,0.001,0.001 c5.793,7.397,7.352,16.785,4.509,27.146c-2.014,7.337-5.614,12.697-5.767,12.921C326.344,86.014,324.484,87,322.495,87z  M127.971,75h191.051c0.881-1.732,1.967-4.196,2.711-7.018c1.722-6.52,0.894-11.999-2.461-16.283 C296.313,22.397,253.329,12,223.495,12c-29.829,0-72.809,10.397-95.768,39.7c-3.354,4.284-4.184,9.763-2.465,16.284 C126.006,70.803,127.089,73.266,127.971,75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M309.83,65.102c-1.78,0-3.543-0.79-4.727-2.3c-7.442-9.499-22.245-22.246-50.501-29.031 c-3.222-0.773-5.206-4.013-4.433-7.235s4.012-5.208,7.235-4.433c17.45,4.19,41.529,13.369,57.144,33.299 c2.044,2.608,1.586,6.379-1.022,8.423C312.429,64.684,311.125,65.102,309.83,65.102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.012,30.433c-0.162,0-0.324-0.007-0.487-0.02c-3.412-0.274-6.786-0.413-10.03-0.413 c-3.313,0-6-2.687-6-6s2.687-6,6-6c3.563,0,7.262,0.152,10.99,0.452c3.304,0.265,5.766,3.158,5.5,6.461 C239.733,28.053,237.107,30.433,234.012,30.433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M322.495,125h-198c-3.313,0-6-2.687-6-6V81c0-3.313,2.687-6,6-6h198c3.313,0,6,2.687,6,6v38 C328.495,122.313,325.809,125,322.495,125z M130.495,113h186V87h-186V113z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M294.005,205c-3.313,0-6-2.687-6-6v-63c0-3.313,2.687-6,6-6s6,2.687,6,6v63 C300.005,202.313,297.318,205,294.005,205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M302.005,108c-3.313,0-6-2.687-6-6v-6c0-3.313,2.687-6,6-6s6,2.687,6,6v6 C308.005,105.313,305.318,108,302.005,108z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman4);
export default __webpack_public_path__ + "static/media/woman4.49fdece353ecbf5a8e86b89d59e23d23.svg";
export { ForwardRef as ReactComponent };